export interface StorageEngine {
  load: () => Promise<unknown>;
  save: (state: unknown) => Promise<unknown>;
}

// Local replacement for `redux-storage-decorator-filter`, which depends on the
// unmaintained, vulnerable `lodash.set` (CVE-2020-8203). Only top-level
// whitelisting is supported, which is all this app uses.
const filterStorageDecorator = <T extends StorageEngine>(
  engine: T,
  whitelist: readonly string[],
): T => ({
  ...engine,
  save: (state: unknown) => {
    const source =
      state !== null && typeof state === 'object'
        ? (state as Record<string, unknown>)
        : {};
    const saveState: Record<string, unknown> = {};

    whitelist.forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(source, key)) return;
      const value = source[key];
      if (value !== undefined) {
        saveState[key] = value;
      }
    });

    return engine.save(saveState);
  },
});

export default filterStorageDecorator;
